import React, { Dispatch, SetStateAction, useState } from "react";
import {
  Attachment,
  AttachOrDownload,
  FileFieldProps,
  IAttachment,
} from "../../common/attachments";
import capitalize from "@material-ui/core/utils/capitalize";
import { Antecedente } from "../../common/Form";
import { AntecedenteDefault } from "../admin-concursos/Mantenedor";

type FileExtension = {
  // esto es lo que ve el usuario
  extension: string; // ej. ".pdf"

  // esto es lo que revisa la validación de formato
  // así nos evitamos problemas de si es por ejemplo .jpg o .jpeg
  mimeType: string; // ej. "application/pdf"
};

export const allowedExtensions: FileExtension[] = [
  { extension: ".pdf", mimeType: "application/pdf" },
  { extension: ".doc", mimeType: "application/msword" },
  { extension: ".jpg", mimeType: "image/jpeg" },
  { extension: ".png", mimeType: "image/png" },
  {
    extension: ".docx",
    mimeType:
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  },
  //{ extension: ".jpg", mimeType: "image/jpeg" },
  //{ extension: ".png", mimeType: "image/png" },
  //{ extension: ".gif", mimeType: "image/gif" },
];

interface IPostulacionAttachment extends IAttachment {
  readonly antecedente: AntecedenteDefault;
}

export class PostulacionAttachment
  extends Attachment
  implements IPostulacionAttachment {
  readonly antecedente: AntecedenteDefault;

  constructor(props: IPostulacionAttachment) {
    super(props);
    this.antecedente = props.antecedente;
  }

  // override
  validate(): string {
    console.log(this.antecedente);
    if (this.antecedente.obligatorio=='0') {
      return "OK";
    }

    if (this.archivo == null) {
      return this.id == -1 ? "Debe elegir un archivo" : "OK";
    }

    const attachmentMimeType = this.archivo.type;
    if (
      !allowedExtensions.some(
        (extension) => attachmentMimeType === extension.mimeType
      )
    ) {
      return "El archivo no pertenece a ninguno de los formatos permitidos";
    }

    return "OK";
  }

  // override
  new(props: IPostulacionAttachment): PostulacionAttachment {
    return new PostulacionAttachment(props);
  }
}

type PostulacionFileFieldProps = FileFieldProps & {
  attachment: PostulacionAttachment;
  setAttachment: Dispatch<SetStateAction<PostulacionAttachment>>;
  isEditing: boolean;
};

export const PostulacionFileField: React.FC<PostulacionFileFieldProps> = (
  props
) => {
  const { attachment, setAttachment } = props;
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);

  if (attachment.deleted) {
    return null;
  }

  const shouldShowError = hasBeenBlurred && !attachment.isValid;

  return (
    <div style={{ marginBottom: "2em" }}>
      <h6
        style={{
          color: "#18528A",
          marginBottom: "-0.5em",
          display: "inline-block",
        }}
      >
        {capitalize(attachment.nombre)}
      </h6>

      {props.attachment.antecedente.obligatorio == '1' && (
        <span style={{ marginLeft: "1em" }}>(Requerido, Solo se permite adjuntar un archivo por antecedente)</span>
      )}

      <AttachOrDownload
        attachment={attachment}
        setAttachment={setAttachment}
        enableAttach
        enableDownload={props.isEditing}
        accept={allowedExtensions.map((e) => e.mimeType).join(",")}
        onBlur={() => setHasBeenBlurred(true)}
        route="downloadFilePostulacion"
      />
      {shouldShowError && (
        <p style={{ color: "red" }}>{attachment.validate()}</p>
      )}
    </div>
  );
};
